module.exports = __webpack_public_path__ + "img/q.15145f39.svg";